import styled from "styled-components";
import * as colors from "../../settings/colors";

const SidebarDivider = styled.div`
  height: 1px;
  margin: 12px;
  background: ${colors.SIDEBAR_DIVIDER};
`;

export default SidebarDivider;



// WEBPACK FOOTER //
// ./src/components/sidebar/SidebarDivider.js